import { render, staticRenderFns } from "./SalesTarget.vue?vue&type=template&id=0842ffc2&scoped=true&"
import script from "./SalesTarget.vue?vue&type=script&lang=js&"
export * from "./SalesTarget.vue?vue&type=script&lang=js&"
import style0 from "./SalesTarget.vue?vue&type=style&index=0&id=0842ffc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842ffc2",
  null
  
)

export default component.exports